/*
export const someGetter = (state) => {}
 */
import _ from 'lodash'
export default {
  courseList,
  certificateList,
  managerList,
  affiliateList,
  courseOptions,
  autoCompleteOptions,
  courseAffiliateOptions,
  courseManagerOptions
}

function courseList (state) {
  return state.list.map(course => {
    return course
  })
}

function certificateList (state) {
  return state.certificates.map(certificate => {
    return certificate
  })
}

function managerList (state) {
  return state.managers.map(manager => {
    return manager
  })
}

function affiliateList (state) {
  return state.affiliates.map(affiliate => {
    return affiliate
  })
}

function courseOptions (state, getters) {
  return getters.courseList.map(course => {
    return { label: course.COURSE_NAME, value: course.COURSE_ID, item: course }
  })
}

function autoCompleteOptions (state, getters, rootState) {
  return state.autoCompleteList.map(course => { 
    return { label: course.COURSE_NAME, value: course.COURSE_NAME, item: course }
  })
}

function courseAffiliateOptions (state, getters, rootState, rootGetters) {
  const affiliateAutoCompleteOptions = rootGetters["users/affiliateAutoCompleteOptions"]
  const courseAffiliates = getters.affiliateList
  return _.differenceWith(affiliateAutoCompleteOptions, courseAffiliates, (affiliateOption, courseAffiliate) => {
    return affiliateOption.item.USER_ID === courseAffiliate.USER_ID
  })
}

function courseManagerOptions (state, getters, rootState, rootGetters) {
  const managerAutoCompleteOptions = rootGetters["users/managerAutoCompleteOptions"]
  const courseManagers = getters.managerList
  return _.differenceWith(managerAutoCompleteOptions, courseManagers, (managerOption, courseManager) => {
    return managerOption.item.USER_ID === courseManager.USER.USER_ID
  })
}

